module.exports = __webpack_public_path__ + "static/img/sequence-smoke-min.b12fc1e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/website/sequence-smoke-min.png
// module id = 676
// module chunks = 64